export const tableMap = {
  'linear_ad_sales': 'las-workbench',
  'social_digital': 'sm-workbench',
  'audience_discovery': 'ad-workbench'
}



// WEBPACK FOOTER //
// ./src/app/router/tableMap.js